"use client";

import { useMemo } from "react";
import { useTable } from "spacetimedb/react";
import { tables } from "@/module_bindings";
import { mapGlaciTag } from "@/lib/stdb-map";
import { useResolvedCurrentOrganization } from "./use-current-organization";
import type { GlaciTag } from "@/types/glaci";

export function useGlaciTags(orgId?: string): {
  tags: GlaciTag[];
  isReady: boolean;
} {
  const current = useResolvedCurrentOrganization();
  const effectiveOrgId = orgId ?? current.organization?.id;

  const [rows, tagsReady] = useTable(tables.org_glaci_tags);

  const tags = useMemo(() => {
    if (!effectiveOrgId) return [];
    return rows
      .filter((row) => row.organizationId === effectiveOrgId)
      .map(mapGlaciTag);
  }, [rows, effectiveOrgId]);

  const isReady = orgId ? tagsReady : tagsReady && current.isReady;

  return { tags, isReady };
}
